import { EyeIcon } from "@heroicons/react/24/outline";
import { useDownloadDocumentMutation } from "../../store/services/DocumentService";
import Loader from "../main/Loader";

export default function DownloadDocument({ label, documento }: any) {
  const [downloadDocument, { isLoading }]: any = useDownloadDocumentMutation();

  const handleDownload = async () => {
    
    const response: any = await downloadDocument({
      idAzienda: documento.aziendaId,
      idDocument: documento.id,
    });

    if (response?.data) {

      window.open(response.data, "_blank");
      
      const downloadLink = document.createElement("a");
      downloadLink.href = response.data;
      downloadLink.setAttribute("download", documento.nome || "documento.pdf");
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }

  };

  return (
    <>
      {isLoading && <Loader />}
      <p className="cursor-pointer flex items-center" onClick={handleDownload}>
        {label}
        <EyeIcon className="w-4 h-4 ml-2" />
      </p>
    </>
  );
}